import React from 'react'
import {PageTitle} from '../../../_metronic/layout/core'
import {useIntl} from 'react-intl'
import AddToStock from '../../modules/add-to-stock/AddToStock'

const AddToStockPage: React.FC = () => {
  const {formatMessage} = useIntl()
  return (
    <>
      <PageTitle>{formatMessage({id: 'MENU.ADD_TO_STOCK'})}</PageTitle>
      <AddToStock />
    </>
  )
}

export default AddToStockPage
